import { render, staticRenderFns } from "./countinue.vue?vue&type=template&id=5372d148&scoped=true&"
import script from "./countinue.ts?vue&type=script&lang=ts&"
export * from "./countinue.ts?vue&type=script&lang=ts&"
import style0 from "./countinue.scss?vue&type=style&index=0&id=5372d148&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5372d148",
  null
  
)

export default component.exports